[
  {
    "titleKey": "nsbTitle",
    "descriptionKey": "nsbDescription"
  },
  {
    "titleKey": "easytimerTitle",
    "descriptionKey": "easytimerDescription"
  },
  {
    "titleKey": "gameTitle",
    "descriptionKey": "gameDescription"
  }
]